export default __webpack_public_path__ + "static/media/mt.b49d2630.jpg";